/**
 * Alevli Rota oyun modları. Mevcut `bridgeMode` taslak/yayın alanı yeniden kullanılır (yeni sütun yok):
 * `guided` = Normal mod (yanlışta doğru kapı gösterilir, sonraki soruya geçilir, can yok, bütün sorular görülür),
 * `challenge` = 3 Can modu. Alanı boş eski Alevli Rota taslak ve yayınları 3 Can modudur.
 */
export const FIERY_ROUTE_MODES = ['guided', 'challenge'] as const;
export type FieryRouteMode = (typeof FIERY_ROUTE_MODES)[number];

export function fieryRouteModeOf(bridgeMode: string | null | undefined): FieryRouteMode {
  return bridgeMode === 'guided' ? 'guided' : 'challenge';
}
